import { Button } from "@brightagency/headstart-common";
import ChatRoundedIcon from "@mui/icons-material/ChatRounded";
import LocalPhoneRoundedIcon from "@mui/icons-material/LocalPhoneRounded";
import React from "react";
import { NeedHelpNowCard } from "../../../constants/types/acf";
import { CardHeader } from "../../atoms/CardHeader";
import { UnstyledLink } from "../../atoms/UnstyledLink";
import { Outer, Content, Title, MobileActionWrapper, Actions, Copy } from "./styled";

interface Props {
    card: NeedHelpNowCard;
}

const CardAction: React.FC<{
    icon: React.ReactNode;
    href: string;
    linkText: string;
    hours: string;
    buttonAppearance: "primary" | "secondary";
}> = props => {
    return (
        <MobileActionWrapper>
            <UnstyledLink target="_blank" rel="noreferrer noopener" href={props.href}>
                <Button
                    iconBefore={props.icon}
                    style={{ width: "100%" }}
                    appearance={props.buttonAppearance}
                    size="small"
                >
                    {props.linkText}
                </Button>
            </UnstyledLink>
            <p>{props.hours}</p>
        </MobileActionWrapper>
    );
};

export const NeedHelpCard: React.FC<Props> = ({ card }) => {
    return (
        <Outer>
            <CardHeader backgroundColor={card.logo_background_colour} imageUrl={card.logo.url} />
            <Content>
                <Title>{card.title}</Title>
                {card.copy && <Copy>{card.copy}</Copy>}
                <Actions>
                    <CardAction
                        buttonAppearance="primary"
                        icon={<LocalPhoneRoundedIcon />}
                        href={`tel:${card.phone.number}`}
                        linkText={`Call ${card.phone.number}`}
                        hours={card.phone.hours}
                    />

                    {card.chat.link && card.chat.hours && (
                        <CardAction
                            buttonAppearance="secondary"
                            icon={<ChatRoundedIcon />}
                            href={card.chat.link}
                            linkText={`Support Chat`}
                            hours={card.chat.hours}
                        />
                    )}
                </Actions>
            </Content>
        </Outer>
    );
};
